
import { CustomLoading } from 'common'


export const ReceiptViewer = ({ useFetchInit }) =>{

    const {
        FetchData
    } = useFetchInit

    const { fetchSpecificTransactionCashier } = FetchData
    const { transactionReceiptBase64, loadingFetchSpecificTransactionCashier } = fetchSpecificTransactionCashier
    const { docName, docBase64 } = transactionReceiptBase64

    return(
        <>
            {(loadingFetchSpecificTransactionCashier)&&(<CustomLoading/>)}
            {(!loadingFetchSpecificTransactionCashier && (docBase64 || docBase64 !== ''))&&(
                <iframe
                    src={docBase64 || null}
                    width="100%"
                    height="700"
                    style={{ border: "none" }}
                    title={docName}
                />
            )}
        </>
    )
}